import { render } from "./PhotographerBadge.vue?vue&type=template&id=277b72e2"
import script from "./PhotographerBadge.vue?vue&type=script&lang=js"
export * from "./PhotographerBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__